import { render, staticRenderFns } from "./activityDashboard.html?vue&type=template&id=20d6838c&external"
import script from "./activityDashboard.vue?vue&type=script&lang=js"
export * from "./activityDashboard.vue?vue&type=script&lang=js"
import style0 from "./activityDashboard.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports